import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './styles.module.scss';

/** ツールチップバブルの表示位置 */
type Position = {
  top: number;
  left: number;
  placement: 'top' | 'bottom';
  /** バブル中央（left）からの矢印の水平オフセット（px）。負値は左方向 */
  arrowOffsetX: number;
};

type Props = {
  /** 表示する内容 */
  content: React.ReactNode;
  /** トリガー側の aria-describedby と紐付けるための id */
  tooltipId: string;
  /** 表示位置 */
  position: Position;
  /** 表示中かどうか */
  isOpen: boolean;
};

export const TooltipPresentation = forwardRef<HTMLSpanElement, Props>(
  ({ content, tooltipId, position, isOpen }, ref) => {
    const style = {
      top: position.top,
      left: position.left,
      '--tooltip-arrow-offset': `${position.arrowOffsetX}px`,
    } as React.CSSProperties;

    return (
      <span
        ref={ref}
        id={tooltipId}
        role='tooltip'
        aria-hidden={!isOpen}
        className={clsx(
          styles.content,
          position.placement === 'bottom' && styles.below,
          isOpen && styles.open
        )}
        style={style}
      >
        {content}
      </span>
    );
  }
);
